import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { BlackboxSetupComponent } from '@components/entities/blackboxes/blackbox-setup/blackbox-setup.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'app-setup-blackbox-dialog-content',
  templateUrl: './setup-blackbox-dialog-content.component.html',
  styleUrls: ['./setup-blackbox-dialog-content.component.scss']
})
export class SetupBlackboxDialogContentComponent extends AbstractDialogContent {

  public className = 'SetupBlackboxDialogContentComponent';

  @ViewChild(BlackboxSetupComponent) blackboxSetupComponent: BlackboxSetupComponent;

  public blackboxSerialNumber: string;
  public step: number = 1;
  public stepCaptions: string[] = [
    'Blackbox',
    'Kunde',
    'Adresse',
    'Ladestationen',
    'Farben',
    'Energiemeter',
  ];

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    injector: Injector
  ) {
    super(activeModal, injector);
  }

  close() {
    this.activeModal.close();
  }

  setStep(step) {this.step = step}
  previousStep() {this.step--}
  nextStep() {this.step++}
}
